import axios from 'axios'

// One instance per table. Boundaries belong to a filter/sort/size and credential scope.
export function createHybridListClient() {
  let context
  let pages = {}
  return async function fetchPage(url, config = {}) {
    const request = new URL(url, window.location.origin)
    request.searchParams.set('pagination', 'hybrid')
    const page = Number(request.searchParams.get('page') || 1)
    const key = new URL(request.toString())
    key.searchParams.delete('page')
    key.searchParams.delete('cursor')
    key.searchParams.sort()
    const nextContext = JSON.stringify([key.toString(), config.headers])
    if (context !== nextContext || page === 1) { context = nextContext; pages = {} }
    if (pages[page]) request.searchParams.set('cursor', pages[page])
    const response = await axios.get(request.toString(), config)
    if (context === nextContext) {
      const info = response.data.pageInfo
      if (info?.nextCursor) pages[page + 1] = info.nextCursor
      if (info?.previousCursor) pages[page - 1] = info.previousCursor
    }
    return response
  }
}
